import { Divider, Drawer, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { updateAsArrived, updateAsNotArrived, updateAsLeft, updateAsNotLeft } from '@/services/vastaanottoService';
import DetailsBody from '@/components/VarausDetails/DetailsBody';
import { useVarausDetails } from '@/hooks/useVarausDetails';
import { toast } from 'react-toastify';
import { CloseOutlined } from '@mui/icons-material';

const DetailsSheet = ({ open, onClose, data }) => {
  const varausId = data?.id?.varausId;
  const { details, error, loading, setDetails } = useVarausDetails(varausId);
  const { t } = useTranslation();

  const onToggleSaapumisStatus = async (field, value) => {
    if (!varausId) return;

    const prev = details;

    setDetails(d => ({ ...d, [field]: value }));

    try {
      if (field === 'saapunut') {
        if (value) await updateAsArrived(data.id.varausId);
        else await updateAsNotArrived(data.id.varausId);
      }
      if (field === 'lahtenyt') {
        if (value) await updateAsLeft(data.id.varausId);
        else await updateAsNotLeft(data.id.varausId);
      }
    }
    catch (e) {
      toast.error(t('detailsSheet.arrivalError'));
      setDetails(prev);
    }
  };

  if (error) {
    toast.error(t('detailsSheet.fetchError'));
    return null;
  }

  if (!details || !details.type) return null;

  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            height: '80vh',
            maxHeight: '90vh',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            overflow: 'hidden',
            paddingBottom: '1em',
          },
        },
      }}
    >
      <div style={{ padding: '1em', display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ display: 'flex' }}>
          <Typography variant="h6" sx={{ flex: 1 }}>
            {details.type === 'normivaraus' ? t('detailsSheet.reservationDetails') : t('detailsSheet.ownReservationDetails')}
          </Typography>

          <IconButton
            onClick={onClose}
            aria-label="close"
            size="small"
          >
            <CloseOutlined />
          </IconButton>
        </div>
        <Divider sx={{ mt: 1 }} />

        <div style={{ flex: 1, overflowY: 'auto' }}>
          <DetailsBody
            data={data}
            details={details}
            onToggleStatus={onToggleSaapumisStatus}
            showSiivous={true}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default DetailsSheet;
